
function App() {
    return <div >
        <div style={{ backgroundColor: '#e8e8e8' }}>
            <div className="container pt-5 pb-5">
                <h1 className="mb-4" style={{ textAlign: 'center', fontWeight: 'bold' }}>Tentang kami Aplikasi Kasir Bagus</h1>
                <p >
                    Aplikasi kasir bagus hadir untuk memenuhi kebutuhan bisnis anda, menjadikan operasional bisnis anda mudah di kelola.
                    Bersama kami jadikan solusi bisnis anda sehingga menjadi perusahaan yang berelektabilitas tinggi
                </p>
            </div>
        </div>

        <div className="container pt-5 pb-5">
            <p>Pesatnya perkembangan teknologi dan digital menuntut pengusahan untuk beradapatasi dalam mengembangkan aktifitas dalam bisnis.
                kami pun membuat inovasi untuk membantu pengusaha membangun perusahaannya sehingga perusahaan dapat beraktifitas lebih produktif lagi,
                kami hadir dengan adanya sistem <b>KASIR BAGUS</b> kami bisa membuat bisnis anda menjadi lebih prodiktif lagi.
                <br />
                <br />
                Beberapa keuntungan yang didapat dengan menggunakan <b>KASIR BAGUS</b> di antaranya :
                <ul>
                    <li>Menciptakan waktu yang efisien dengan menyederhanakan proses bisnis</li>
                    <li>Meningkatkan produktifitas</li>
                    <li>Mengurangi biaya operasional</li>
                </ul>
            </p>

            <p>Bergabunglah menjadi mitra kami, dan kami akan memberikan pelayanan yang terbaik untuk perusahaan anda.</p>
        </div>
    </div>
}

export default App